module.exports = __webpack_public_path__ + "static/2-1d116cf32999e36521fde3067eefdee1.jpg";